import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Contact.css';
import './css/Pages.css';
import './css/Fonts.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import ContactFormBoundary from './ContactFormBoundary';
import ContactFormLive from './ContactFormLive';
import ContactFormStatic from './ContactFormStatic';
import { useLiveContactForm } from './contactFormConfig';

// The page shell. Which form goes in it is decided by contactFormConfig, driven
// by REACT_APP_CONTACT_FORM_LIVE. Default is the static form, which cannot fail.
function Contact() {
  const form = useLiveContactForm ? (
    <ContactFormBoundary fallback={<ContactFormStatic />}>
      <ContactFormLive />
    </ContactFormBoundary>
  ) : (
    <ContactFormStatic />
  );

  return (
    <div className="page">
      <header className="page-header">
        <Container>
          <p className="page-eyebrow">Contact</p>
          <h1 className="page-title">Request a demo</h1>
          <p className="page-lead">
            Tell us what you are running today and what you are trying to replace. We will show you
            the applications that fit.
          </p>
        </Container>
      </header>

      <Container className="page-section">
        <Row className="g-5">
          <Col lg={7}>
            {form}
            <p className="contact-privacy-note">
              We use what you send us to respond to your inquiry. See our{' '}
              <Link to="/legal/privacy">Privacy Policy</Link>.
            </p>
          </Col>

          <Col lg={5}>
            <div className="contact-aside">
              <h2 className="contact-aside-title">What happens next</h2>
              <ol className="contact-steps">
                <li>We reply and set up a short call to understand your operation.</li>
                <li>We walk you through the applications that match your processes.</li>
                <li>We scope integration against the systems you already run.</li>
              </ol>
              <div className="contact-aside-divider" />
              <p className="contact-aside-note">
                Already a customer? Reach out through your account team for support.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Contact;
